import React from 'react'
import { useMediaQuery } from 'usehooks-ts'

import styles from './banner.module.scss'

export type BannerItemProps = {
  title: string
  description?: string
  image: string
  imageMobile?: string
  link?: string
  openInNewTab?: boolean
  className?: string
}

export type BannerData = {
  name?: string | null
  button_text?: string | null
  bannerSlide?: { url?: string | null } | null
  bannerMobileSlide?: { url?: string | null } | null
  url?: string | null
  optionOpenInNewWindow?: boolean | null
}

export const shouldRenderBanner = (banner: BannerData | null | undefined): boolean => {
  if (!banner) return false
  if (!banner.name) return false
  if (!banner.bannerSlide?.url) return false
  return true
}

const BannerItem: React.FC<BannerItemProps> = ({
  title,
  description,
  image,
  imageMobile,
  link,
  openInNewTab = false,
  className = ''
}) => {
  const isMobile = useMediaQuery('(max-width: 991px)')
  const imageSrc = isMobile && imageMobile ? imageMobile : image

  const content = (
    <div className={`${styles.banner} ${className}`}>
      <img src={imageSrc} alt={title} className={styles.banner__image} />
      <div className={styles.banner__title}>{title}</div>
      {description && <div className={styles.banner__description}>{description}</div>}
    </div>
  )

  if (link) {
    return (
      <a
        href={link}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        className={styles.banner__link}
      >
        {content}
      </a>
    )
  }

  return content
}

export default BannerItem
